<template>
    <div class="section-locations" :class="color">
        <layout-contained :class="padding">
            <content-heading
                v-if="heading"
                :heading="heading"
                :headingColor="headingColor"
                :headingComponent="headingComponent"
                marginBottom="mb-6"
                :textCentered="textCentered"
            ></content-heading>
            <layout-columns>
                <div>
                    <content-subheading heading="Yorkshire Division"></content-subheading>
                    <div class="py-4">
                        <iframe
                            width="100%"
                            height="320"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2357.276355155258!2d-1.5324931232414605!3d53.784568772419654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48795c39716d5f83%3A0xdc94e00cdba235da!2sMatrix%20House%2C%20Goodman%20St%2C%20Hunslet%2C%20Leeds%20LS10%201NZ!5e0!3m2!1sen!2suk!4v1748341099762!5m2!1sen!2suk"
                        ></iframe>
                    </div>
                    <p class="font-bold">Freeway Recruitment Leeds</p>
                    <address class="pb-8">
                        Leeds Branch (Head Office)<br />
                        Matrix House Goodman Street<br />
                        Hunslet<br />
                        Leeds<br />
                        West Yorkshire<br />
                        LS10 1NZ
                    </address>
                    <p class="text-2xl">Telephone: 0113 277 7000</p>
                    <p class="text-lg">
                        Email:
                        <a class="text-sky-700 hover:underline" href="mailto:info@freewayrecruitment.com"
                            >info@freewayrecruitment.com</a
                        >
                    </p>
                </div>
                <div>
                    <content-subheading heading="North West Division"></content-subheading>
                    <div class="py-4">
                        <iframe
                            width="100%"
                            height="320"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7982.839242478705!2d-2.210161382512241!3d53.49861630497171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487bb102731592c7%3A0x7e46dcca7bda5b17!2sFreeway+Recruitment!5e0!3m2!1sen!2suk!4v1450119174948"
                        ></iframe>
                    </div>
                    <p class="font-bold">Freeway Recruitment Manchester</p>
                    <address class="pb-8">
                        Manchester Branch<br />
                        Newton Heath Business Centre<br />
                        Wilsons House<br />
                        Monsall Road<br />
                        Manchester<br />
                        M40 8WN
                    </address>
                    <p class="text-2xl">Telephone: 0161 205 66 12</p>
                    <p class="text-lg">
                        Email:
                        <a class="text-sky-700 hover:underline" href="mailto:manchester.driving@freewayrecruitment.com"
                            >manchester.driving@freewayrecruitment.com</a
                        >
                    </p>
                </div>
            </layout-columns>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'SectionLocations',
    props: {
        padding: {
            required: false,
            default: 'py-12 sm:py-14',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: null,
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
};
</script>
